import { Injectable, Component, Inject, OnInit } from '@angular/core';
import { UserInfo } from '../userInfo';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { SBHttpServicesService } from './services/sbhttp-services.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

import { parseDate } from '@telerik/kendo-intl';
import { Languges } from '../Languages';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';


import { CustomReturn } from '../CustomReturn';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { UserPermissions } from '../UserPermissions';

import { shareReplay } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { any, forEach } from 'underscore';
import { Guid } from 'guid-typescript';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerVisibilityService } from 'ng-http-loader';


export interface DialogData {
  animal: string;
  name: string;
}


declare var $: any;
@Injectable()

export class SharedHandlersService implements OnInit {
  fieldName: any;
  labelText: any;
  response: any;
  parentDataItem: any;
  childDataItem: any;
  notFound: boolean = false;
  GroupingMode: string = "1";
  isGroupLoad: boolean = false;
  gridActionsFunctions = []
  BtnCalculateCost: boolean = false;
  public LookUpsValidation: any = [];
  public currentSelection: number[] = [];
  showSideBar: boolean = true;

  constructor(private environment: AppConfigService, public dialog: MatDialog, private toastr: ToastrService, private httpService: SBHttpServicesService,
    private jwtHelper: JwtHelperService, private _router: Router, private http: HttpClient, public lang: Languges, private spinner: SpinnerVisibilityService,
     
    private Dialog: DialogService, public translate: TranslateService) {

    //if (!this.defaultImagePath || this.defaultImagePath == '')
      //this.getImagePath();

   // if (!this.GlobalImagePath || this.GlobalImagePath == '')
      //this.getGlobalImagePath();

    this.fraction = '1.0-' + this.environment.Percision;
  }
  async ngOnInit() {
  }
  mode: string = "";
  queryValue: string;
  queryKey: string;
  btnMode: string = "";
  FunctionsDisabled: boolean = true;
  TableDisplayMode: string = "";
  BrowseMode: number = UserInfo.BrowserType;
  _selectedRow;//ismail
  public currentObject;//for save datacollection
  public ExistGridsDataArrays = {};
  public dialogPopUPRef: DialogRef;
  public screenMode; // EditMode or NewMode
  public defaultImagePath;//'https://bifmcg.bi-technologies.net/SalesBuzzGamification/assets/images/competitionimages/';//'http://bi-db2008-dev/bisalesbuzzbo/ClientUpgradeFiles/MediaFiles/CompetitionImages/';
  public GlobalImagePath: string;
  ScreenData; //getting value
  public subject = new Subject<any>();
  public ConfirmSubject = new Subject<any>();
  public ButtonNameChangeEvent = new Subject<any>();
  public SaveChangeSubject = new Subject<any>();
  public NavigatorChangeSubject = new Subject<any>();
  public AfterGridSaveChanges = new Subject<any>();
  public ClosePopupSubject = new Subject<any>();
  public CancelGridsEvenet = new Subject<any>();
  public QuestionnaireData$ = new Subject<any>();
  public gridFillResponseEvent = new Subject<any>();
  public ReloadGridEvent = new Subject<any>();
  public UpdateTapEvent = new Subject<any>();//if screen is tabs , event is used to go to the first tab
  public MapCoordsEvent = new Subject<any>();//if pin on map component and we need to update map with new lat and long
  public ReloadControlEvent = new Subject<any>();
  public ReloadDropListEvent = new Subject<any>();
  public ReloadDropdownBtnEvent = new Subject<any>();
  public ClearCacheEvent = new Subject<any>();
  public CheckLookupValue = new Subject<any>();
  public AfterScreenLoadsEvent = new Subject<any>();
  public AfterParentGridSelectItemEvent = new Subject<any>();
  public AfterScreenLoadsDltBtnChildDisabled = new Subject<any>();
  public LoadDependantGridsEvent = new Subject<any>();
  public ChangeLookupSelectionEvent = new Subject<any>();
  public ChangeDroplistSelectionEvent = new Subject<any>();
  public AfterPActionFuncClicked = new Subject<any>();
  public EnableDsiableControlEvent = new BehaviorSubject<any>(null);
  public CurrentScreenID: string;
  public ScreenPopups: { [id: string]: DialogRef; } = {};
  public screenParam: any = "";
  public ScreenConditions = {}
  public Navigatordatasource: string[];
  public route: string;
  public ShardHeaderRow: any;
  public PSKUcolors;
  public MenuItems;
  public isAllDisabled = false;
  public DTOObject: any = {};
  public OriginalDTOObject: any = {};
  public gridAllData: any = {};
  public lookupsData: any = {};
  public droplistsData: any = {};
  public StaticObject: any;
  public WillAbbreviationChangeValue: boolean = true;
  public KeepRow: boolean = false;
  public DefultValuesObject: any = {};
  fraction: string = '';
  public alerts: any = [];
  public AfterRenderEvent = new Subject<any>();

  private NavigatepageBehavior = new BehaviorSubject<number>(0);
  //1=> first page
  //2=> pervoius page
  //3=> next page
  //4=> last page
  NavigatepageBehaviorObservable = this.NavigatepageBehavior.asObservable();
  Navigatepage(data: any) {
    this.NavigatepageBehavior.next(data);
  }
  private AttributesDefaultValues = new BehaviorSubject<any>([]);
  DefaultValuesObservable = this.AttributesDefaultValues.asObservable();
  OnDefaultValuesChange(data: any) {
    this.AttributesDefaultValues.next(data);
  }

  showLoader() {
    this.spinner.show();
  }

  hideLoader() {
    this.spinner.hide();
  }


  // --------------------------------------------------

  private AddObjToList = new BehaviorSubject<any>({ Loadfunction: "", data: {} });
  AddObjToListObservable = this.AddObjToList.asObservable();

  ReplaceRowAfterSave(data: any) {
    this.AddObjToList.next(data);
    this.currentSelection = [];
    this.currentSelection.push(0);
  }

  private AddObjToListChild = new BehaviorSubject<any>({ Loadfunction: "", data: {} });
  AddObjToListObservableChild = this.AddObjToListChild.asObservable();

  ReplaceRowAfterSaveChild(data: any) {
    this.AddObjToListChild.next(data);
  }
  //----------------------------------------------

  //screenId: schema screen id (metadata)
  //screenIdentity: Id for the data of the screen
  //ActionData hold the screenId, screenIdentityCol, Maintable and isEditable or not
  async ChangeMode(mode: string, screenMetadata, screenIdentity) {
    if (!mode)
      await this.currentMode(screenMetadata, screenIdentity);
    else this.mode = mode;

    //console.log("view");
    //console.log(this.mode);

    if (this.mode == 'view')
      this.DisableControls();
    else
      this.EnableControls();

  }

  public async currentMode(screenMetadata, screenIdentity, Module = null) {
    var SecurityKey = null;
    //1- Check User Authority to access this screen
    if (Module != null && screenMetadata['ModuleScreen'].length > 0) {
      SecurityKey = screenMetadata['ModuleScreen'].filter(f => f.QueryStringParam == "Module=" + Module)[0]['SecurityKey'];
    }
    else {
      SecurityKey = screenMetadata["SecurityKeyID"];
    }
    await this.CheckSecurityKeyPermision(SecurityKey);
    if (UserPermissions.CanRead) {


      //2- check screen if isEditable (screen details)
      if ((screenMetadata["MainTable"] || screenMetadata["WorkflowType"]) && screenIdentity) {
        var url = this.environment.apiRoot + 'api/Supervisor/RequestStatus/' +
          screenMetadata["MainTable"]["Idfield"] + '/' +
          screenMetadata["MainTable"]["TableName"] + '/' +
          screenMetadata["MainTable"]["StatusField"] + '/' +
          screenIdentity + '/' +
          screenMetadata["MainTable"]["TableId"] + '/' +
          screenMetadata["MainTable"]["StatusCondition"] + '/' +
          screenMetadata["WorkflowType"];
        var data = await this.httpService.httpGetRequest(url);
        if (data) {
          //TableDisplayMode reference for item status only
          this.TableDisplayMode = data['data'];

        }
      }
      if (!screenMetadata["IsEditable"]) {
        this.mode = 'view';
      }
      else if (screenMetadata["IsEditable"] && screenIdentity) {
        if (data) {
          //check user authority
          if (UserPermissions.CanInsert || UserPermissions.CanUpdate || UserPermissions.CanDelete)
            this.mode = data['data'];
          else
            this.mode = 'view';
        }
        else {
          if (UserPermissions.CanInsert || UserPermissions.CanUpdate || UserPermissions.CanDelete)
            this.mode = 'edit';
          else
            this.mode = 'view';
        }
      }
      else if (screenMetadata["IsEditable"] && !screenIdentity) {
        //check user authority
        if (UserPermissions.CanInsert || UserPermissions.CanUpdate || UserPermissions.CanDelete)
          this.mode = 'edit';
        else
          this.mode = 'view';
      }
      else if (screenMetadata["MainTable"] && !screenIdentity) {
        this.mode = 'new';

      }


      if (this.mode == 'view') {
        this.DisableControls();
      }

    }
    else {
      this._router.navigate(['/unauthorized']);
    }
  }
  //######################## Get Mode for Child [start]  #####################//
  public async checkMode(screenMetadata, screenIdentity) {
    if ((screenMetadata && (screenMetadata["MainTable"] || screenMetadata["WorkflowType"])) && screenIdentity) {
      var url = this.environment.apiRoot + 'api/Supervisor/RequestStatus/' +
        screenMetadata["MainTable"]["Idfield"] + '/' +
        screenMetadata["MainTable"]["TableName"] + '/' +
        screenMetadata["MainTable"]["StatusField"] + '/' +
        screenIdentity + '/' +
        screenMetadata["MainTable"]["TableId"] + '/' +
        screenMetadata["MainTable"]["StatusCondition"] + '/' +
        screenMetadata["WorkflowType"];
      //console.log(url);
      var data = await this.httpService.httpGetRequest(url);

    }
    if (data) {
      //check user can update
      if (UserPermissions.CanUpdate)
        this.mode = data['data'];
      else
        this.mode = 'view';
      //console.log(this.mode);
    }
    else
      this.mode = 'view';
    if (screenMetadata && screenMetadata["MainTable"] && !screenIdentity) {
      this.mode = 'edit';//new
    }
  }
  //######################## Get Mode for Child [end]  #####################//

  //EnableControls() {
  //    // alert(this.mode);
  //}

  EnableControlByID(controlName) {
    $('#' + controlName + ' span').removeClass("k-state-disabled");
  }

  EnableControls() {
    // $('#actionButtons').prop('disabled', true);kendo-grid-toolbar
    // $('a').on('click.myDisable', function (e) { e.preventDefault(); });
    $("#actionButtons *").removeAttr("disabled").on('click');
    $(".k-grid").removeClass("k-state-disabled");
    $("input").removeAttr("disabled");
    $("button").not("#Layout_Cards").removeAttr("disabled");
    $(".k-input").removeClass("k-state-disabled");
    $(".k-dropdown-wrap").removeClass("k-state-disabled");//disable dropdown

    //Enable Layout buttons
    $("#Layout_Cards").removeAttr("disabled")
    $("#Layout_Grids").removeAttr("disabled")
  }

  EnableAllScreen() {
    this.isAllDisabled = false;
    this.EnableControls();
  }

  DisableControls(disablekgrid = true) {
    // $('#actionButtons').prop('disabled', true);kendo-grid-toolbar
    // $('a').on('click.myDisable', function (e) { e.preventDefault(); });
    $("#actionButtons *").attr("disabled", "disabled").off('click');
    if (disablekgrid)
      $(".k-grid").addClass("k-state-disabled");
    $("input").attr("disabled", "disabled");
    $("button").not("#Layout_Cards").attr("disabled", "disabled");
    $(".k-input").addClass("k-state-disabled");
    $(".k-dropdown-wrap").addClass("k-state-disabled");//disable dropdown

    //Enable Layout buttons
    $("#Layout_Cards").removeAttr("disabled")
    $("#Layout_Grids").removeAttr("disabled")
    $('.button-menu-mobile').removeAttr("disabled")

  }

  DisableAllScreen(KGrid = true) {
    this.isAllDisabled = true;
    this.DisableControls(KGrid);
  }

  DisableByControlID(controlId) {
    //console.log("controlId");
    //console.log($("input[name =" + controlId + "]"));
    $("input[name =" + controlId + "]").disabled = true;
    // $("input[name =" + controlId + "]").prop('disabled', true);
    //$("input[name =FilterText]").attr("disabled", "disabled");
  }

  RefreshPage() {
    window.location.reload();
  }

  ChangeInputProp(inputName: string, prop: string) {
    let propName = prop.split('=')[0];
    let propValue = prop.split('=')[1];
    //console.log($(inputName));
    $(inputName).each(function () {
      $(this).prop(propName, propValue);
    });
    //this._refresh.sendClickCall();
  }





 




  async GetHeaderObject(HeaderURL) {
    var Header = await this.getURL(this.environment.apiRoot + HeaderURL);
    this.currentObject["Header"] = Header;
  }

  sumTotalOfData(data: []) {
    var total = 0;
    ////console.log(data);
    for (var i = 0; i < data.length; i++) {
      total = total + data[i]['Value'] as number;
    }
    return total;
  }

  async GetMode(CurrentControlClass: string, screenMetadata, screenIdentity) {
    await this.currentMode(screenMetadata, screenIdentity);
    //console.log(this.mode);

    if (this.mode == 'view')
      $("'#" + CurrentControlClass + "'").attr("disabled", "disabled").off('click');

  }

  test() { return true; }

  async error(error: string, AttributeId: any = null) {
    this.alerts = this.alerts.filter(x => x.attributeId != AttributeId);
    this.alerts.push({ type: 'error', msg: this.getName(error), attributeId: AttributeId });
    // this.AlertsDic.set("","");
    //this.toastr.error(this.getName(error), null, { closeButton: true, disableTimeOut: true });
  }

  async Success(Msg: string) {
    //this.alerts.push({ type: 'success', msg: this.getName(Msg) });
    this.toastr.success(this.getName(Msg), null, { closeButton: true });
  }
  async Warning(Msg: string) {
    this.alerts.push({ type: 'warning', msg: this.getName(Msg) });
    //this.toastr.success(this.getName(Msg));
  }
  public closeAlert(index) {
    this.alerts.splice(index, 1);

  }

  public closeAlertbyAttributeId(AttributeId) {
    // this.alerts.splice(index, 1);
    this.alerts = this.alerts.filter(x => x.attributeId != AttributeId);
  }
  public HasAlert() {
    if (this.alerts && this.alerts.length > 0) return true;
    else return false;
  }

  hasTranslation(translationKey: string): boolean {
    const translations = this.translate.translations[this.translate.currentLang];
    return translations && translations[translationKey] !== undefined;
  }

  public getName(key: string): string {
    return this.translate.instant(key || " ");
  }

  public getFormInputs() {

    var x = document.getElementsByTagName("INPUT");
    var y = [];
    var FormDataLst = [];
    var cnt2 = 0;

    for (var cnt = 0; cnt < x.length; cnt++) {
      if (x[cnt]["type"] == "text" || x[cnt]["type"] == "number" || x[cnt]["type"] == "date" || x[cnt]["type"] == "checkbox" || x[cnt]["type"] == "datetime-local")
        y.push(x[cnt]);
    }

    for (var i = 0; i < y.length; i++) {
      var data = {};
      data["type"] = y[i].type;
      data["name"] = (y[i].Name) ? y[i].Name : y[i].id;
      if (y[i].type == 'checkbox')
        data["value"] = y[i].checked?'1':'0 '
      else
        data["value"] = y[i].value;
      if (data["name"] && data["name"].length < 10)
        FormDataLst.push(data);
    }
    y = [];
    x = document.getElementsByTagName("KENDO-DROPDOWNLIST");
    for (var cnt = 0; cnt < x.length; cnt++) {
      if (x[cnt]["id"]) y.push(x[cnt]);
    }

    for (var i = 0; i < y.length; i++) {
      var data = {};
      data["type"] = y[i].type;
      data["name"] = (y[i].Name) ? y[i].Name : y[i].id;
      //  data["value"] = (y[i].attributes && y[i].attributes['ng-reflect-model'] && y[i].attributes['ng-reflect-model'].nodeValue) ? y[i].attributes['ng-reflect-model'].nodeValue : "";
      data["value"] = (y[i]?.innerText) ? y[i].innerText : ''  //fix the PDA wrong mapping 
      FormDataLst.push(data);
    }
    return FormDataLst;
  }

  

  public SelectedRow(selectedRow) {//ismail
    this._selectedRow = selectedRow;
  }
  //#############Competition Edit ####################//
  public static FormatDate(date_) {//ismail
    if (date_ == null || date_ == undefined || date_ == '')
      return '';
    // else {
    //   var tempdDate = parseDate(date_);
    //   return tempdDate.getFullYear() + '-' + ('0' + (tempdDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tempdDate.getDate()).slice(-2);
    // }
  }

  public FormatDate2(date_) {//ismail
    if (date_ == null || date_ == undefined || date_ == '')
      return '';
    else {
      return date_
      // var tempdDate = parseDate(date_);
      // 
      // return tempdDate.getFullYear() + '-' + ('0' + (tempdDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tempdDate.getDate()).slice(-2);
    }
  }

  getDate() {//ismail
    var today = new Date();
    return today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
  }

  getDateTime() {//ismail
    var today = new Date();
    return today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2) + ' ' +
      today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
  }

  public static FormatDateTime(date_) {//Omar
    if (date_ == null || date_ == undefined || date_ == '')
      return '';
    else {
      var tt = parseDate(date_);
      return tt.getFullYear() + '-' + ('0' + (tt.getMonth() + 1)).slice(-2) + '-' + ('0' + tt.getDate()).slice(-2);//ismail
    }
  }

  setDefualtValue(control: any, isEval = true) {
    if (control.DefaultValue) {
      if (control.DefaultValue == 'getDate()') {
        let getDateVar = this.getDate();
        control.DefaultValue = getDateVar;
      }
      else if (control.DefaultValue == 'getDateTime()') {
        let getDateVar = this.getDateTime();
        control.DefaultValue = getDateVar;
      }
      else if (control.DefaultValue == 'getCurrentUser()') {
        let getCurrentUser = UserInfo.UserCode;
        control.DefaultValue = getCurrentUser;
      }
      else if (control.DefaultValue == 'getCurrentUserName()') {
        let getCurrentUserName = UserInfo.UserName;
        control.DefaultValue = getCurrentUserName;
      }
      else if (control.DefaultValue == 'getCurrentBUName()') {
        let getCurrentBUname = UserInfo.BusinessUnitName;
        control.DefaultValue = getCurrentBUname;
      }
      else if (control.DefaultValue == 'getCurrentBUid()') {
        let getCurrentBUid = UserInfo.BUID;
        control.DefaultValue = getCurrentBUid;
      }
      else if (isNaN(control.DefaultValue) && control.DefaultValue.includes('getParamByID(')) {
        let getCurrentUserName = this.getParamByIDObs$(control.DefaultValue.replace('getParamByID(', '').replace(')', ''));
        control.DefaultValue = getCurrentUserName;
      }
      else if (control.DefaultValue == 'getCurrentUserImage()') {
        control.DefaultValue = this.defaultImagePath + UserInfo.UserCode + '.jpg';
      }
      else if (control.DefaultValue == 'getPercentage()') {
        let pres = document.getElementsByName("ProgressButton").item(0).innerText.replace('%', '');
        control.DefaultValue = pres;
      }
      else if (control.DefaultValue.toString().includes('api')) {
        return '';
      }
      else if (control.DefaultValue.toString().includes('routeParam')) {
        if (this.currentObject)
          control.DefaultValue = this.currentObject['HeaderData'][control.AttributeName];
        else
          return '';
      }
      else {
        // Ex in screen 30: control.DefaultValue = this.currentObject['HeaderData'][control.AttributeName];
        try {
          if (isEval)
            eval(control.DefaultValue);
        } catch (e) {
        }
      }
    }
    if (control.DefaultValue == undefined)
      control.DefaultValue = '';



    if ((control.DataType == 'int' || control.DataType == 'float' || control.DataType == 'bit') && control.DefaultValue !== '') {
      //New condition [&& control.DefaultValue !== ''] added to avoid binding with 0 if empty
      //it was not a problem if anyone need to remove new condition , remove it
      let converter: number = control.DefaultValue;
      let c = +converter;
      if (!isNaN(c))
        control.DefaultValue = c;
    }
    return control.DefaultValue;
  }

  async getURL(url) {
    var data = await this.httpService.httpGetRequest(url);
    if (data["status"] == CustomReturn.Succeed) {
      return data.data
    }
    return data;
  }

  setControlsValues(rowItem) {

    //fill all the controls  on the tabs withe selected rowitems
    //filter all attributes on the screen that has no datasource
    var dsAttributes = this.ScreenData["ScreenAttributes"].filter(x => x.ScreenDataSourceId == undefined);
    for (var value of dsAttributes) {
      if (!value.DefaultValue.includes('('))
        if (value.DataType != 'date') {
          this.currentObject[value.AttributeName] = rowItem[value.AttributeName];
        }
        else if (value.DataType == 'date') {
          this.currentObject[value.AttributeName] = SharedHandlersService.FormatDate(rowItem[value.AttributeName]);
        }
    }
  }

  ValidateInputControls(): Boolean {
    //validate Input Controls On Submit

    var IsValid: Boolean = true;
    var screenAttributes = this.ScreenData["ScreenAttributes"].filter(c => c.ScreenDataSourceId == undefined);
    var errorMessage: string;
    IsValid = this.ValidateRequiredFields(screenAttributes)
    if (IsValid == true) {
      //Check On Other Validtion;
      // Future Validation will be functions  checkes return boolen
    }

    return IsValid;
  }

  ValidateControls(): Boolean {
    //validate Input Controls On Submit

    var IsValid: Boolean = true;
    var screenAttributes = this.ScreenData["ScreenAttributes"];
    var errorMessage: string;
    IsValid = this.ValidateRequiredInputs(screenAttributes)
    if (IsValid == true) {
      //Check On Other Validtion;
      // Future Validation will be functions  checkes return boolen
    }

    return IsValid;
  }

  ValidateRequiredInputs(ScreenAttributes): Boolean {
    var IsValid: Boolean = true;
    var requiredFields = ScreenAttributes.filter(c => c.IsRequired == true);
    var emptyFields = "";

    for (var element of requiredFields) {


      if (this.currentObject['HeaderData'][element.AttributeName] === "") {
        emptyFields = this.translate.instant(element.Name) + " " + this.translate.instant("is required") + ".\n";
      }
      else if (this.currentObject['HeaderData'][element.AttributeName] == null) {
        if (element.Name && element.Name != '' && element.Name != undefined)
          emptyFields = this.translate.instant(element.Name) + " " + this.translate.instant("is required") + ".\n";
        else emptyFields = this.translate.instant(element.AttributeName) + " " + this.translate.instant("is required") + ".\n";
      }
      if (this.currentObject['HeaderData'][element.AttributeName] === "" || this.currentObject['HeaderData'][element.AttributeName] == null) {
        //this.toastr.error(emptyFields);
        this.error(emptyFields);
        IsValid = false;
      }

      //break;
    }
    //if (IsValid == false) {
    //
    //    var errorMessage = emptyFields;
    //    this.toastr.error(errorMessage);
    //}
    return IsValid;
  }

  ValidateRequiredFields(ScreenAttributes): Boolean {
    var IsValid: Boolean = true;
    var requiredFields = ScreenAttributes.filter(c => c.IsRequired == true);
    var emptyFields = "";
    if (this.currentObject['GridsCreatedItemsArrays'] && this.currentObject['ParentScreenDataSource']
      && this.currentObject['GridsCreatedItemsArrays'][this.currentObject['ParentScreenDataSource']]
      && this.currentObject['GridsCreatedItemsArrays'][this.currentObject['ParentScreenDataSource']].length > 0) {
      for (var element of requiredFields) {
        if (this.currentObject['GridsCreatedItemsArrays'][this.currentObject['ParentScreenDataSource']][0][element.AttributeName] === ""
          || this.currentObject['GridsCreatedItemsArrays'][this.currentObject['ParentScreenDataSource']][0][element.AttributeName] == null) {
          emptyFields = this.translate.instant(element.Name) + " " + this.translate.instant("IsRequired") + ".\n";
          this.error(emptyFields);
          IsValid = false;
        }
      }
    }
    else {
      for (var element of requiredFields) {
        if (this.currentObject['HeaderData'][element.AttributeName] === "" || this.currentObject['HeaderData'][element.AttributeName] == null) {
          emptyFields = this.translate.instant(element.Name) + " " + this.translate.instant("IsRequired") + ".\n";
          this.error(emptyFields);
          IsValid = false;
        }
      }
    }
    return IsValid;
  }

 


  SaveCallBackFunctionFailure(data) {
    // this function for callback function in case of failure of the saving

    this.screenMode = 'new';
    //
    this.error(data['message'])

  }





  sendCancelGridsEvenet(message: any) {
    this.CancelGridsEvenet.next({ text: message });
  }

  getCancelGridsEvenet(): Observable<any> {
    return this.CancelGridsEvenet.asObservable();
  }

  setQuestionnaireData$(message: any) {
    this.QuestionnaireData$.next({ value: message });
  }

  getQuestionnaireData$(): Observable<any> {
    return this.QuestionnaireData$.asObservable();
  }

  sendGridSaveChangesEvent(message: any) {
    //console.log("grid change");
    this.AfterGridSaveChanges.next({ text: message });
  }

  getGridSaveChangesEvent(): Observable<any> {
    return this.AfterGridSaveChanges.asObservable();
  }
  ///////////////////////////////////////
  //message: must be datasource name
  //condition: if you need any condition like 'filter'
  //           OR if there is condition for the datasource url(most common in child grid)
  //rowIndex: if you need to select and highlight a row.
  //reloadGrid: if you need to reload the grid.
  //            new request will be called.
  //            takecare of the filter and condition if equal true.
  //fromReloadEvent: usually keep its default value. but it is used when you need to fill grid while the value of PreventInitiateGrid is true
  ///////////////////////////////////////
  sendReloadGridEvent(message: any, condition: string = "", rowIndex: number = null, reloadGrid: boolean = true, fromReloadEvent: boolean = false) {
    //Reload the datasource of this name or all data sources in case of "all"
    this.ReloadGridEvent.next({ datasourceName: message, Condition: condition, rowIndex: rowIndex, reloadGrid, fromReloadEvent });
  }

  getReloadGridEvent(): Observable<any> {
    //Reload the datasource of this name or all data sources in case of "all"
    return this.ReloadGridEvent.asObservable();
  }

  sendUpdateTapEvent(message: any) {//if screen is tabs , event is used to go to the first tab
    this.UpdateTapEvent.next({ tab: message });
  }

  getUpdateTapEvent(): Observable<any> {//if screen is tabs , event is used to go to the first tab
    return this.UpdateTapEvent.asObservable();
  }

  sendMapCoordsEvent(message: any) {//if pin on map component and we need to update map with new lat and long
    this.MapCoordsEvent.next({ coords: message });
  }

  getMapCoordsEvent(): Observable<any> {//if pin on map component and we need to update map with new lat and long
    return this.MapCoordsEvent.asObservable();
  }

  sendReloadControlEvent(message: any, objectValue) {
    //Reload the datasource of this name or all data sources in case of "all"
    this.ReloadControlEvent.next({ controlName: message, Value: objectValue });
  }

  getReloadControlEvent(): Observable<any> {
    return this.ReloadControlEvent.asObservable();
  }
  sendReloadDropListEvent(name: any, list) {
    this.ReloadDropListEvent.next({ Name: name, droplist: list });
  }

  getReloadDropListEvent(): Observable<any> {
    return this.ReloadDropListEvent.asObservable();
  }
  sendReloadDropdownBtnEvent(name: any, list) {
    this.ReloadDropdownBtnEvent.next({ Name: name, droplist: list });
  }

  getReloadDropdownBtnEvent(): Observable<any> {
    return this.ReloadDropdownBtnEvent.asObservable();
  }
  sendLoadDependantGridsEvent(condition: any, name: any) {
    this.LoadDependantGridsEvent.next({ datasourceName: name, gridCondtition: condition });
  }
  sendChangeLookupSelectionEvent(message: any, value) {
    //Reload the datasource of this name or all data sources in case of "all"
    this.ChangeLookupSelectionEvent.next({ lookupName: message, Value: value });
  }

  getChangeLookupSelectionEvent(): Observable<any> {
    //Reload the datasource of this name or all data sources in case of "all"
    return this.ChangeLookupSelectionEvent.asObservable();
  }
  sendChangedropSelectionEvent(message: any, value) {
    //Reload the datasource of this name or all data sources in case of "all"
    this.ChangeDroplistSelectionEvent.next({ dropName: message, Value: value });
  }

  getChangeDroplistSelectionEvent(): Observable<any> {
    //Reload the datasource of this name or all data sources in case of "all"
    return this.ChangeDroplistSelectionEvent.asObservable();
  }
  getLoadDependantGridsEvent(): Observable<any> {
    //Reload the datasource of this name or all data sources in case of "all"
    return this.LoadDependantGridsEvent.asObservable();
  }

  sendClearCacheEvent(message: any) {
    // fire event to clear cache and reload all needed process (menu)
    this.ClearCacheEvent.next({ text: message });
  }
  getClearCacheEvent(): Observable<any> {

    return this.ClearCacheEvent.asObservable();
  }

  sendCheckLookupValue(message) {
    this.CheckLookupValue.next({ message });
  }

  getCheckLookupValue(): Observable<any> {
    return this.CheckLookupValue.asObservable();
  }

  sendEnableDsiableControlEvent(name: any, value) {
    // fire event to clear cache and reload all needed process (menu)
    this.EnableDsiableControlEvent.next({ name: name, value });
  }
  getEnableDsiableControlEvent(): Observable<any> {

    return this.EnableDsiableControlEvent.asObservable();
  }


  getAfterScreenLoadsEvent(): Observable<any> {// child and parent
    return this.AfterScreenLoadsEvent.asObservable();
  }

  SetBehaviorForAfterScreenLoadsEvent(msg: any) {
    this.AfterScreenLoadsEvent.next(msg);
  }

  getAfterParentGridSelectItemEvent(): Observable<any> {// child and parent
    return this.AfterParentGridSelectItemEvent.asObservable();
  }

  SetBehaviorForAfterParentGridSelectItemEvent(msg: any) {
    this.AfterParentGridSelectItemEvent.next(msg);
  }

  SetBehaviorForAfterPActionFuncClicked(msg: any) {
    this.AfterPActionFuncClicked.next(msg);
  }

  getAfterPActionFuncClicked() {
    return this.AfterPActionFuncClicked.asObservable();
  }

  getAfterScreenLoadsDltBtnChildDisabled(): Observable<any> {// child and parent
    return this.AfterScreenLoadsDltBtnChildDisabled.asObservable();
  }

  SetBehaviorForAfterScreenLoadsDltBtnChildDisabled(msg: any) {
    this.AfterScreenLoadsDltBtnChildDisabled.next(msg);
  }

  sendAfterScreenLoadsEvent(message: any) {
    this.AfterGridSaveChanges.next({ text: message });
  }
  // ############## Competition Edit ############## //
  sendGridChange(message: boolean) {
    this.ConfirmSubject.next({ text: message });
  }

  getGridChange(): Observable<any> {
    return this.ConfirmSubject.asObservable();
  }

  async sendGridChangeSave(message: boolean) {

    this.SaveChangeSubject.next({ text: message });
  }

  getGridFillResponse(): Observable<any> {
    return this.gridFillResponseEvent.asObservable();
  }

  async sendGridFillResponse(Datasourcekey: string) {

    this.gridFillResponseEvent.next({ text: Datasourcekey });
  }

  getGridChangeSave(): Observable<any> {
    return this.SaveChangeSubject.asObservable();
  }

  sendPopupCloseEvent(message: string) {
    this.ClosePopupSubject.next({ text: message });
  }

  sendButtonNameChange(key: string, message: string) {
    this.ButtonNameChangeEvent.next({ text: key, buttonText: message });
  }

  getButtonNameChange(): Observable<any> {
    return this.ButtonNameChangeEvent.asObservable();
  }

  sendNavigatorChange(message: string) {
    this.NavigatorChangeSubject.next({ text: message });
  }
  GetNavigatorChange(): Observable<any> {

    return this.NavigatorChangeSubject.asObservable();
  }

  sendAfterRenderEvent(gridData: any) {
    this.AfterRenderEvent.next(gridData);
  }
  GetAfterRenderEvent(): Observable<any> {
    return this.AfterRenderEvent.asObservable();
  }

  getPopupCloseEvent(): Observable<any> {
    return this.ClosePopupSubject.asObservable();
  }

  async getImagePath() {
    var url = this.environment.apiRoot + 'api/Supervisor/GetImagePath';
    var data = await this.httpService.httpGetRequest(url, "", false);
    if (data) {
      this.defaultImagePath = data;
    }
  }

  async getGlobalImagePath() {
    var url = this.environment.apiRoot + 'api/Supervisor/GetGlobalImagePath';
    var data = await this.httpService.httpGetRequest(url, "", false);
    if (data) {
      this.GlobalImagePath = data;
    }
  }

  async getNavigatorDatasource() {

    var params = this.route.split("&&").filter(c => c.includes("CustomerNo"));

    for (var p of params) {
      let parts = p.split(':')

      var customerno = parts[1];
    }
    var url = this.environment.apiRoot + 'api/SalesOrder/GetOrderFilterNavigation/' + customerno + '';
    let data = await this.httpService.httpGetRequest(url);
    if (data)
      return data['data'];

  }

  async getImage(Image: string, code: string, goal: string = '') {
    if (!Image)
      Image = '""';
    if (goal == '')
      goal = '""';
    var url = this.environment.apiRoot + 'api/Supervisor/ImageFileToShow/' + Image + '/' + code + '/' + goal;
    var data = await this.httpService.httpGetRequest(url);
    return data;
  }

  public setActivatedRouteParam(RouteParam) {
    var params;
    if (RouteParam) {
      let condition = RouteParam;
      this.route = RouteParam;
      if (condition.includes('&&'))
        params = condition.split("&&");
      else
        params = condition.split(";");
      for (var p of params) {
        let parts = p.split(':')
        if (parts[0] != undefined) {
          if (parts[1] != undefined)
            this.ScreenConditions[parts[0]] = parts[1];
        }
      }
    }

  }
  public GetActivatedRouteParamForLookup(RouteParam) {
    var params;
    var LookupFilter = '';;
    if (RouteParam) {
      let condition = RouteParam;
      this.route = RouteParam;
      if (condition.includes('&&'))
        params = condition.split("&&");
      else
        params = condition.split(";");
      for (var p of params) {
        let parts = p.split(':')
        if (parts[0] != undefined) {
          if (parts[1] != undefined)
            LookupFilter += '@' + parts[0] + "='" + parts[1] + "',";
        }
      }
      LookupFilter = LookupFilter.substring(0, LookupFilter.length - 1);

    }
    return LookupFilter;
  }

  public GetActivatedRouteRequiredParamForLookup(RouteParam, requiredParams) {
    var params;
    var LookupFilter = '';;
    if (RouteParam) {
      let condition = RouteParam;
      this.route = RouteParam;
      if (condition.includes('&&'))
        params = condition.split("&&");
      else
        params = condition.split(";");
      for (var p of params) {
        let parts = p.split(':')
        if (parts[0] != undefined) {
          if (parts[1] != undefined && requiredParams.indexOf(parts[0]) > -1)
            LookupFilter += '@' + parts[0] + "='" + parts[1] + "',";
        }
      }
      LookupFilter = LookupFilter.substring(0, LookupFilter.length - 1);

    }
    return LookupFilter;
  }
  //public async CheckQuestionairePopup(apiRoute) {

  //    var data = await this.httpService.httpGetRequest(this.environment.apiRoot + apiRoute);
  //    if (data["TotalCount"] > 0) {

  //       // this.openPopupByScreen(38, "view");
  //    } else {
  //        this.DisableControls();
  //        this.ClosePopupByTitle('OrderConfirmation');
  //    }
  //}

  public getKeyValue(key: any, dictionary) {
    while (key.includes('{')) {

      let cond = key.substring(key.indexOf('{') + 1, key.indexOf('}'));
      key = key.replace('{' + cond + '}', dictionary[cond]);
    }
    return key;
  }
  //Here we Compare FromDate and ToDate
  checkDate(Date: string) {
    if (this.currentObject["HeaderData"]['FromDate'] > Date) {
      alert('To Date Should greater than From Date');
      this.currentObject["HeaderData"]['ToDate'] = this.getDate();
    }
  }
  //Here if from date greater than ToDate
  checkFromDate(Date: string) {
    if (this.currentObject["HeaderData"]['ToDate'] < Date) {
      alert('To Date Should greater than From Date');
      this.currentObject["HeaderData"]['FromDate'] = this.getDate();
    }
  }

  async CheckSecurityKeyPermision(ScreenSecKey: string) {
    var IgnorSecurity = localStorage.getItem("IgnorSecurity");
    if (IgnorSecurity && IgnorSecurity == 'true')
      this.EnableAllPermission();

    if (ScreenSecKey) {
      var token = localStorage.getItem("jwt");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        //  console.log('token');
        var AllToken = this.jwtHelper.decodeToken(token);
        // console.log(AllToken);
        if (AllToken["role"]) {
          if (AllToken["role"] == 'Administrator') {
            this.EnableAllPermission();
          }
          else {
            // console.log(AllToken["role"]);
            var RoleClaimurl = this.environment.apiRoot + 'api/Account/GetRoleClaims/' + AllToken["role"] + '/' + ScreenSecKey;
            var data = await this.httpService.httpGetRequest(RoleClaimurl);
            if (data) {
              var PermArr = data.split(',');
              for (var i = 0; i < PermArr.length; ++i) {
                //  this.CurrentUserPermission[PermArr[i].substring(0, 1)] = PermArr[i].substring(PermArr[i].indexOf(':'), 1);
                if (PermArr[i].substring(0, 1) == "0")
                  UserPermissions.CanRead = (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
                else if (PermArr[i].substring(0, 1) == "1")
                  UserPermissions.CanInsert = (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
                else if (PermArr[i].substring(0, 1) == "2")
                  UserPermissions.CanUpdate = (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
                else if (PermArr[i].substring(0, 1) == "3")
                  UserPermissions.CanDelete = (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
                else if (PermArr[i].substring(0, 1) == "4")
                  UserPermissions.CanExecute = (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
              }
            }
            else
              this.DisableAllPermissions();
          }
        }
        else {
          this.DisableAllPermissions();
        }

      }
    }
    else {
      this.EnableAllPermission();
    }
    //console.log(UserPermissions);
  }

  async GetActionSecurityKeyPermision(ActionSecKey: string) {
    if (ActionSecKey) {
      var token = localStorage.getItem("jwt");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        var AllToken = this.jwtHelper.decodeToken(token);
        if (AllToken["role"]) {
          if (AllToken["role"] == 'Administrator') {
            return true;
          }
          else {
            var RoleClaimurl = this.environment.apiRoot + 'api/Account/GetRoleClaims/' + AllToken["role"] + '/' + ActionSecKey;
            var data = await this.httpService.httpGetRequest(RoleClaimurl);
            if (data) {
              var PermArr = data.split(',');
              for (var i = 0; i < PermArr.length; ++i) {
                if (PermArr[i].substring(0, 1) == "4")
                  return (PermArr[i].substring(PermArr[i].indexOf(':') + 1) == "1") ? true : false;
              }
            }
            else
              return false;
          }
        }
        else {
          return false;
        }

      }
    }
    else {
      return true;
    }
  }

  DisableAllPermissions() {
    UserPermissions.CanRead = false;
    UserPermissions.CanInsert = false;
    UserPermissions.CanUpdate = false;
    UserPermissions.CanDelete = false;
    UserPermissions.CanExecute = false;
  }

  EnableAllPermission() {
    UserPermissions.CanRead = true;
    UserPermissions.CanInsert = true;
    UserPermissions.CanUpdate = true;
    UserPermissions.CanDelete = true;
    UserPermissions.CanExecute = true;
  }

  async GetMenuItems(ClearCache = false, forceSwitch = false) {
    var token = localStorage.getItem("jwt");
    var FWToken = localStorage.getItem("FWToken");
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      var AllToken = this.jwtHelper.decodeToken(token);
      if (!forceSwitch) {
        UserInfo.BrowserType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 1 : 0;
      }
      var url = this.environment.apiRoot + 'api/schema/GetMenuScreens/' + UserInfo.BrowserType + '/' + AllToken["role"] + '/' + ClearCache;
      var MenuItems = await this.httpService.httpGetRequest(url, "", false);
      if (MenuItems && MenuItems["status"] && MenuItems["status"] == 2) {
        Swal.fire({
          html: `<div>Error</div><div style=font-size:15px>${MenuItems["message"]}</div>`,
          showCloseButton: true,
          background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
          showConfirmButton: false
        });
        return;
      }
      return MenuItems;
    }
  }

  async ClearScreenCache(ScreenID) {
    var url = this.environment.apiRoot + 'api/schema/ClearScreenCache/' + ScreenID;
    var result = await this.httpService.httpGetRequest(url);
    return result;
  }

  RemoveLocalStorage() {
    //remove filter local storage
    let keys = Object.keys(localStorage);
    ////console.log("keys");
    var i, results = [];
    for (i in localStorage) {
      if (localStorage.hasOwnProperty(i)) {
        if (i.match('FilterValues') || (!'FilterValues' && typeof i === 'string')) {
          localStorage.removeItem(i);
        }
      }
    }
  }

  ShowWarningMessage(warningMsg) {
    if (warningMsg)
      this.toastr.warning(warningMsg);
  }



  //Object to send = this.shared.currentobject.selecteditem['customers'][0]
  //{
  //'id':1,
  //'desc':'',
  //'ardesc':''
  //'sales':{'id':1,this.shared.curObj[HD]['sales']}
  //}
  //ResourceObject = this.shared



  getCurrentUser() {
    return UserInfo.UserCode;
  }

  getCurrentUserName() {
    return UserInfo.UserName;
  }

  getCurrentBUID() {
    return UserInfo.BUID;
  }

  async getParamByID(ID) {
    var url = this.environment.oDataApi + '/api/parameters/GetParamValue?ParamId=' + ID;
    return await this.httpService.httpGetRequest(url);
  }

  getParamByIDObs$(ID, AttributeName?: any) {
    var url = this.environment.apiRoot + 'api/Supervisor/GetParamValueJson/' + ID;
    this.httpService.httpGetRequestObs$(url).subscribe(res => {
      if (AttributeName) this.currentObject["HeaderData"][AttributeName] = res['data'];
    })
  }

  DisableOrEnableControl(isDisable, control) {
    if (document.getElementById(control)) {
      if (isDisable)
        document.getElementById(control).setAttribute("disabled", "disabled");
      else
        document.getElementById(control).removeAttribute("disabled");

    }
  }

  CalcRedius(x) {
    return x * Math.PI / 180;
  }

  CalculateDistance(p1, p2) {
    //p1=>CustomerLocation
    //p2=>SalesManLocation
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.CalcRedius(p2.latitude - p1.latitude);
    var dLong = this.CalcRedius(p2.longitude - p1.longitude);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.CalcRedius(p1.latitude)) * Math.cos(this.CalcRedius(p2.latitude)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  }

  openInfoDialog(msg, data = '') {
    Swal.fire({
      html: `<div>${this.translate.instant('Warning')}</div><div style=font-size:15px>${this.translate.instant(msg) + ' ' + data}</div>`,
      showCloseButton: true,
      background: '#fff url(assets/images/warning_amber_black_24dp.svg) center center no-repeat',
      showConfirmButton: true,
      confirmButtonText: this.translate.instant('OK')
    });
  }

  SetPercisionRound(val) {
    if (val == null || val == '' || isNaN(val))
      return val;
    else
      return parseFloat(val).toFixed(this.environment.Percision);
  }

  CheckObjectEquality(objectToSearchIn, objectToCompareWith, fields = [], excludedfields = [], screenAttributes = []) {
    let equal = true;
    Object.entries(objectToSearchIn).forEach(entry => {
      let [key, value] = entry;
      if (((fields.length > 0 && fields.includes(key)) || fields.length == 0) && (objectToSearchIn[key] != objectToCompareWith[key] && objectToCompareWith.hasOwnProperty(key))
        && !excludedfields.includes(key)) {
        equal = false;
      }
    });
    return equal;
  }

  AreAllFieldsInObjectNull(objectToSearchIn) {
    let isNull_ = true;
    Object.entries(objectToSearchIn).forEach(entry => {
      let [key, value] = entry;
      if (objectToSearchIn[key] != null) {
        isNull_ = false;
      }
    });
    return isNull_;
  }

  RemoveAllFromString(value, valueToBeRemoved) {
    if (value.toString().includes(valueToBeRemoved)) {
      value = value.replace(valueToBeRemoved, '');
      return this.RemoveAllFromString(value, valueToBeRemoved)
    }
    else {
      return value;
    }
  }

  ReplaceAllFromString(value, valueToBeRemoved, valueToBeReplaced) {
    if (value.toString().includes(valueToBeRemoved)) {
      value = value.replace(valueToBeRemoved, valueToBeReplaced);
      return this.ReplaceAllFromString(value, valueToBeRemoved, valueToBeReplaced)
    }
    else {
      return value;
    }
  }

  GetConditionValue(condition): any {
    if (condition == 'CurrentSalesman') {
      return UserInfo.UserCode;
    }
    else if (condition == 'BUID') {
      return UserInfo.BUID;
    }
    else if (condition == 'Lang') {
      return UserInfo.Language.toString();
    }

    else if (this.currentObject && this.currentObject['HeaderData']
      && this.currentObject['HeaderData'].hasOwnProperty(condition)) {
      if (this.currentObject[condition + "_Type"]) {
        var type = this.currentObject[condition + "_Type"];
        if (type == "numeric")
          return Number(this.currentObject['HeaderData'][condition]);
        else return this.currentObject['HeaderData'][condition];
      }
      else return this.currentObject['HeaderData'][condition];
    }
    else if (this.ScreenConditions && this.ScreenConditions.hasOwnProperty(condition)) {
      return this.ScreenConditions[condition];
    }
    //else if (exist in localstorage) {//lama tet3mel isa
    //    return valueIsa;
    //}
    else
      return '';
  }


  GenerateRowGuid() {
    var rowGuid: Guid;
    rowGuid = Guid.create();
    return rowGuid;
  }

  NewGuid() {
    var rowGuid: Guid;
    rowGuid = Guid.create();
    return rowGuid["value"];
  }

  SetObjectDefaultValues(obj) {
    var getAttrsWithInt = this.ScreenData["ScreenAttributes"].filter(att => att.DataType == 'int' || att.DataType == 'bit');
    Object.keys(obj).forEach(function (key) {
      var foundAttr = getAttrsWithInt.find(s => s['AttributeName'] == key);
      if (foundAttr && (obj[key] == "" || obj[key] == null || obj[key] == undefined)) {
        obj[key] = 0;
      }
    });
    return obj;
  }

  //destLat and destLong is the destination lat and long where you should be or near by
  //sourceLat and sourceLong is where i am now
  //GetDistanceFromLatLonInKm(destLat, destLong, sourceLat, sourceLong) {
  //    destLat = 30.0556088;
  //    destLong = 31.3557841;
  //    //sourceLat = 30.0565096;//260m
  //    //sourceLong = 31.3600649;//260m
  //    sourceLat = 30.0565467;//700m
  //    sourceLong = 31.3596894;//700m
  //    var R = 6371; // Radius of the earth in km
  //    var dLat = this.deg2rad(sourceLat - destLat);  // deg2rad below
  //    var dLon = this.deg2rad(sourceLong - destLong);
  //    var a =
  //        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //        Math.cos(this.deg2rad(destLat)) * Math.cos(this.deg2rad(sourceLat)) *
  //        Math.sin(dLon / 2) * Math.sin(dLon / 2);
  //    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //    var d = R * c; // Distance in km
  //    return d;
  //}

  //deg2rad(deg) {
  //    return deg * (Math.PI / 180)
  //}

  SetUserLanguage(userLang: number) {
    if (localStorage.getItem('isRightToLeft') != null) {
      return localStorage.getItem("isRightToLeft") == 'rtl' ? 1 : 2;
    }
    else {

      let val = userLang == 1 ? 'rtl' : 'ltr';
      localStorage.setItem("isRightToLeft", val);
      return userLang;
    }

  }
  //Type Of Lookup
  //detail = attributes {ctrMetadata}
  ConditionODataString(ctrMetadata, stateParameter, currentGridRow = null, parentGridRow = null) {
    if (ctrMetadata && ctrMetadata['ControlType'] && ctrMetadata['ControlType'] == 'lookup') {
      if (!stateParameter)
        stateParameter = {};
      if (!stateParameter.hasOwnProperty('filter') || !stateParameter['filter'])
        stateParameter['filter'] = { 'filters': [], 'logic': 'and' };
      if (!Array.isArray(stateParameter['filter']['filters'])) {
        stateParameter['filter']['filters'] = [];
      }
      let conditions = [];//array holding all filters while getting data {lookup condition and lookup filter}
      conditions = this.GetConditions(ctrMetadata, currentGridRow, parentGridRow);
      for (let idx in conditions) {
        //InActive ne 1
        let splitOperator = conditions[idx].split(' ')[1];
        let fieldOperatorValue = conditions[idx].split(' ' + splitOperator + ' ');
        let intValue: number = null;
        if (fieldOperatorValue.length > 1 && fieldOperatorValue.length == 2) {
          if (stateParameter['filter'] != undefined && stateParameter['filter']['filters'].length > 0
            && stateParameter['filter']['filters'][0]['filters'].filter(s => s.field == fieldOperatorValue[0]).length == 0) {
            if (!isNaN(fieldOperatorValue[1]) && !fieldOperatorValue[1].includes("'") && !fieldOperatorValue[1].includes('"')) {//if valid number
              intValue = +fieldOperatorValue[1];//to not add quotes '' for int value
            }
            stateParameter['filter']['filters'][0]['filters'].push({ 'field': fieldOperatorValue[0], 'operator': splitOperator, 'value': (intValue == null ? fieldOperatorValue[1] : intValue) });
          }
        }
      }
      return stateParameter;
    }
    else
      return {};//cases from future
  }
  GetConditions(ctrMetadata, currentGridRow = null, parentGridRow = null) {
    let conditions = [];//array holding all filters while getting data {lookup condition and lookup filter}
    if (ctrMetadata && ctrMetadata['LookupCondition']) {
      conditions = ctrMetadata['LookupCondition'].split('&');
    }
    if (ctrMetadata['LookupFilter']) {
      let lookupFilters = ctrMetadata['LookupFilter'].split(',');
      for (let item of lookupFilters) {
        let valueOfFilter = '';
        if (currentGridRow && currentGridRow[item])
          valueOfFilter = currentGridRow[item];
        else if (parentGridRow && parentGridRow[item]) {
          valueOfFilter = parentGridRow[item];
        }
        else {
          if (item.endsWith("=")) {
            return []
          } else {
            valueOfFilter = this.GetConditionValue(item);
          };
        }
        if (valueOfFilter === '')
          valueOfFilter = "''";
        if (item == "BUID")
          conditions.push(item + ' eq ' + "'" + valueOfFilter + "'");
        else
          conditions.push(item + ' eq ' + (valueOfFilter.toString() == 'true' ? 1 : valueOfFilter.toString() == 'false' ? 0 : valueOfFilter));
      }
    }

    return conditions;
  }
  ClearErroListBeforeSave() {
    this.alerts = this.alerts.filter(x => x.type == 'error');
    if (this.alerts.length > 0) {
      this.ShowAlert('pleasecheckerrors');
    }
    return this.alerts.length > 0;

  }
  ClearErrors() {
    this.alerts = [];
  }
  ShowAlert(msg) {
    Swal.fire({
      html: `<div>${this.translate.instant('Warning')}</div><div style=font-size:15px>${this.getName(msg)}</div>`,
      showCloseButton: true,
      background: '#fff url(assets/images/warning_amber_black_24dp.svg) center center no-repeat',
      showConfirmButton: false,
    });
  }

  openErrorDialog(errorMessageResource: string, InnerException: string) {
    var ErrorDetails = "Error Details";
    if (UserInfo.Language == 1)
      ErrorDetails = "عرض التفاصيل";
    let innerExceptionHtml = `
  <a class="btn btn-primary mt-1" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
   `+ ErrorDetails +
      `</a>` + `
<div class="collapse" id="collapseExample">
  <div class="card card-body">`+
      InnerException + `
  </div>
</div> `;
    if (InnerException == '' || InnerException == null || InnerException == undefined) {
      innerExceptionHtml = '';
    }
    Swal.fire({
      html: `<div>${this.translate.instant('error')}</div><div style=font-size:15px>${this.getName(errorMessageResource) + innerExceptionHtml}</div>`,
      showCloseButton: true,
      background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
      showConfirmButton: false
    });
  }

  public deepCopy<T>(instance: T): T {
    if (instance == null) {
      return instance;
    }

    // handle Dates
    if (instance instanceof Date) {
      return new Date(instance.getTime()) as any;
    }

    // handle Array types
    if (instance instanceof Array) {
      var cloneArr = [] as any[];
      (instance as any[]).forEach((value) => { cloneArr.push(value) });
      // for nested objects
      return cloneArr.map((value: any) => this.deepCopy<any>(value)) as any;
    }
    // handle objects
    if (instance instanceof Object) {
      var copyInstance = {
        ...(instance as { [key: string]: any }
        )
      } as { [key: string]: any };
      for (var attr in instance) {
        if ((instance as Object).hasOwnProperty(attr))
          copyInstance[attr] = this.deepCopy<any>(instance[attr]);
      }
      return copyInstance as T;
    }
    // handling primitive data types
    return instance;
  }

}
